var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 163,
    viewBox: "0 0 6 163",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 162.887L5.88675 160L3 157.113L0.113249 160L3 162.887ZM2.5 0V1H3.5V0H2.5ZM2.5 3V5H3.5V3H2.5ZM2.5 7V9H3.5V7H2.5ZM2.5 11V13H3.5V11H2.5ZM2.5 15V17H3.5V15H2.5ZM2.5 19V21H3.5V19H2.5ZM2.5 23V25H3.5V23H2.5ZM2.5 27V29H3.5V27H2.5ZM2.5 31V33H3.5V31H2.5ZM2.5 35V37H3.5V35H2.5ZM2.5 39V41H3.5V39H2.5ZM2.5 43V45H3.5V43H2.5ZM2.5 47V49H3.5V47H2.5ZM2.5 51V53H3.5V51H2.5ZM2.5 55V57H3.5V55H2.5ZM2.5 59V61H3.5V59H2.5ZM2.5 63V65H3.5V63H2.5ZM2.5 67V69H3.5V67H2.5ZM2.5 71V73H3.5V71H2.5ZM2.5 75V77H3.5V75H2.5ZM2.5 79V81H3.5V79H2.5ZM2.5 83V85H3.5V83H2.5ZM2.5 87V89H3.5V87H2.5ZM2.5 91V93H3.5V91H2.5ZM2.5 95V97H3.5V95H2.5ZM2.5 99V101H3.5V99H2.5ZM2.5 103V105H3.5V103H2.5ZM2.5 107V109H3.5V107H2.5ZM2.5 111V113H3.5V111H2.5ZM2.5 115V117H3.5V115H2.5ZM2.5 119V121H3.5V119H2.5ZM2.5 123V125H3.5V123H2.5ZM2.5 127V129H3.5V127H2.5ZM2.5 131V133H3.5V131H2.5ZM2.5 135V137H3.5V135H2.5ZM2.5 139V141H3.5V139H2.5ZM2.5 143V145H3.5V143H2.5ZM2.5 147V149H3.5V147H2.5ZM2.5 151V153H3.5V151H2.5ZM2.5 155V157H3.5V155H2.5ZM2.5 159V160H3.5V159H2.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.403be547cdf28b2eb3d6b7bdaf35c3d5.svg";
export { ForwardRef as ReactComponent };